import { Tab, Tabs } from '@mui/material';
import { useAtom } from 'jotai';
import { NavLink, Outlet, useLocation } from 'react-router';

import Header from '@/layout/Header/Header';
import MainContent from '@/layout/MainContent';
import { selectedOrganizationAtom } from '@/pages/Organizations';
import { checkPermissions } from '@/services/permissions';
import userAtom from '@/store/user.store';

import { DEVICES_TABS } from './Devices.constants';
import useStyles from './Devices.styles';

const DeviceTabs = () => {
  const { classes } = useStyles({ deviceDetailsCollapsed: true });
  const { pathname } = useLocation();
  const [user] = useAtom(userAtom);
  const [selectedOrganization] = useAtom(selectedOrganizationAtom);
  const devicesTabValue =
    DEVICES_TABS.find((tabItem) => tabItem.path === pathname)?.value || 0;

  return (
    <Tabs
      allowScrollButtonsMobile
      aria-label="admin tabs"
      sx={{ pl: '1.5rem' }}
      value={devicesTabValue}
      variant="scrollable"
      scrollButtons={false}
    >
      {DEVICES_TABS.map(
        (tabItem) =>
          checkPermissions(tabItem.permissions, user, selectedOrganization) && (
            <Tab
              key={tabItem.ariaLabel}
              component={NavLink}
              to={tabItem.path}
              label={tabItem.label}
              value={tabItem.value}
              className={classes.tab}
            />
          )
      )}
    </Tabs>
  );
};

const DevicesMain = () => {
  return (
    <>
      <Header title="Devices">
        <DeviceTabs />
      </Header>
      <MainContent>
        <Outlet />
      </MainContent>
    </>
  );
};

export default DevicesMain;
